import { html } from "lit";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { getContainerClasses, getWrapperClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfProgressBar = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_size = "small";
    this.dsf_progress = 0;
  }
  /**
   * Normalized progress value between 0 and 100
   */
  get progress() {
    return Math.min(100, Math.max(0, this.dsf_progress));
  }
  render() {
    return html`<div class=${getContainerClasses(this)}>
      <div class=${getWrapperClasses(this)} style=${`width: ${this.progress}%`}></div>
    </div>`;
  }
};
DsfProgressBar.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
__decorateClass([
  prop({ type: String, reflect: true })
], DsfProgressBar.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: Number })
], DsfProgressBar.prototype, "dsf_progress", 2);
DsfProgressBar = __decorateClass([
  defineElement("dsf-progress-bar")
], DsfProgressBar);
export {
  DsfProgressBar
};
